import React, { Component } from 'react';

export default class Resume extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="resume">			 
			<div className="row education">
				<div className="three columns header-col">
					<h1><span>Education</span></h1>
				</div>
				
				<div className="nine columns main-col">
					<div className="row item">
						<div className="twelve columns">						
							<h3>Art et métiers of La Louvière</h3>
							
							<p className="info">Bachelor in Management Computer Science <span>•</span> <em className="date">2009 - 2013</em></p>
							
							<p>
							Bachelor of management information in social advancement (graduation work: media rental site under Wamp)
							</p>
						</div>
					</div> 					
					
					<div className="row item">
						<div className="twelve columns">
							<h3>Administrative employee</h3>
						
							<p className="info">Administrative employee in Forem Formation in Haine-Saint-Pierre<span>•</span> <em className="date">2006</em></p>
							
							<p>
							6 month of trainee in Administrative employee with an end of training course
							</p>
						 </div>
					</div> 
				</div> 
			</div> 
			
			<div className="row work">
				<div className="three columns header-col">
					<h1><span>Work</span></h1>
				</div>
				
				<div className="nine columns main-col">
					<div className="row item">
						<div className="twelve columns">
							<h3>PP Company</h3>
							
							<p className="info">Web Developer (trainee)<span>•</span> <em className="date">2013</em></p>
							
							<p>
							Development of a personality test in XML and PHP, applications on images and download images in PHP and JavaScript, redesign the structure, code and 
							CSS design of a section of an online site
							</p>
					  </div>
					</div> 
					
					<div className="row item">
						<div className="twelve columns">
							
							<h3>Addvantages</h3>
							<p className="info">Web Developer WordPress (trainee)<span>•</span> <em className="date">2015</em></p>
							<p>
							Development of a WordPress site for my professional profile and a site for a musical project, with integration of modules and integration and configuration 
							of WooCommerce.
							</p>
						</div>
					</div> 
					
					<div className="row item">
						<div className="twelve columns">
							
							<h3>Alpaga Studio</h3>
							<p className="info">Web Developer Python (trainee)<span>•</span> <em className="date">2016</em></p>
							<p>
							Python language study, PHP refreshing and upgrading.
							</p>
						</div>
					</div> 
				</div> 
			</div> 
       
			<div className="row skill">
				<div className="three columns header-col">
					<h1><span>Skills</span></h1>
				</div>
				
				  <div className="nine columns main-col">
						<p>
						I'm working to have a complete Web Developer profile.
						</p>
						
						<div className="bars">
							 <ul class="skills">
								<li><span class="bar-expand illustrator"></span><em>Adaptive/Responsive Design</em></li>
								<li><span class="bar-expand css"></span><em>Bootstrap Twitter/Bootswatch</em></li>
								<li><span class="bar-expand css"></span><em>HTML5</em></li>
								<li><span class="bar-expand css"></span><em>CSS3</em></li>
								<li><span class="bar-expand wordpress"></span><em>Sass</em></li>
								<li><span class="bar-expand wordpress"></span><em>Less</em></li>
								<li><span class="bar-expand html5"></span><em>PHP</em></li>								
								<li><span class="bar-expand photoshop"></span><em>JavaScript</em></li>
								<li><span class="bar-expand photoshop"></span><em>jQuery</em></li>	
								<li><span class="bar-expand wordpress"></span><em>Ajax</em></li>
								<li><span class="bar-expand html5"></span><em>MySQL</em></li>
								<li><span class="bar-expand illustrator"></span><em>XML</em></li>
								<li><span class="bar-expand illustrator"></span><em>JSON</em></li>								
								<li><span class="bar-expand wordpress"></span><em>Java</em></li>								
								<li><span class="bar-expand photoshop"></span><em>Drupal</em></li>
								<li><span class="bar-expand html5"></span><em>WordPress</em></li>	
								<li><span class="bar-expand photoshop"></span><em>Prestashop</em></li>	
								<li><span class="bar-expand photoshop"></span><em>Joomla</em></li>	
								<li><span class="bar-expand wordpress"></span><em>Magento</em></li>
								<li><span class="bar-expand illustrator"></span><em>SEO</em></li>
								<li><span class="bar-expand illustrator"></span><em>UML</em></li>
								<li><span class="bar-expand illustrator"></span><em>Symfony2</em></li>
								<li><span class="bar-expand illustrator"></span><em>Zend</em></li>
								<li><span class="bar-expand illustrator"></span><em>Laravel</em></li>
								<li><span class="bar-expand wordpress"></span><em>Angular JS</em></li>
								<li><span class="bar-expand wordpress"></span><em>Node.js</em></li>								
								<li><span class="bar-expand wordpress"></span><em>Photoshop</em></li>
								<li><span class="bar-expand html5"></span><em>Windows</em></li>
								<li><span class="bar-expand wordpress"></span><em>Linux</em></li>								
							</ul>
						</div>
				  </div> 
			</div> 
		</section>  
	  }   
      </React.Fragment>
    );
  }
}
